import UsersService from '@/services/users.service';
import documentsService from '@/services/documents.service';

export default {
    name: 'SignatureType',
    props: ['uuid', 'signature_type', 'accountDraftData', 'status'],

    data() {
        return {
            editable: false,
            uuidAccount: '',
            signatureType: '',
            isLoading: false,
            otpActive: false,
            otpVerification: undefined,
            interveners: [],
            account: {},
            updating: false,
            deleting: false,
            juridicalDocuments: [
                {
                    key: 'ESTATUTOS_VIGENTES',
                    label: 'Estatutos vigentes',
                    file: null
                },
                {
                    key: 'ESCRITURA_O_ACTA_DE_CONSTITUCION',
                    label: 'Escritura o acta de constitución',
                    file: null
                },
                {
                    key: 'ESCRITURAS_DE_PODERES',
                    label: 'Escrituras de poderes',
                    file: null
                },
                {
                    key: 'IDENTIFICACION_ESTRUCTURA_DE_PROPIEDAD_Y_CONTROL',
                    label: 'Identificación estructura de propiedad y control',
                    file: null
                }
            ],
            showInvalidDocumentSize: false,
            acceptedFormats: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
            maxSizeInBytes: 10000000
        };
    },

    async mounted() {
        this.uuidAccount = this.uuid;
        this.signatureType = this.signature_type;
        await Promise.all([await this.loadAccountData(this.uuidAccount)]);
        this.loadIntervenersData();

        this.$root.$on('dismiss', () => (this.otpActive = false));
        this.$root.$on('close-otp-modal', () => (this.otpActive = false));
    },

    beforeDestroy() {
        this.$root.$off('dismiss');
        this.$root.$off('close-otp-modal');
    },

    methods: {
        edit(status) {
            this.editable = status ? true : false;
        },

        cancel() {
            this.editable = false;
            this.signatureType = this.signature_type;
        },
        async loadAccountData(uuidAccount) {
            const response = await this.$accountService.getAccount(null, uuidAccount);
            this.account = response.data.account;
        },

        activateOTP(action) {
            const OTPData = {
                otp_type: 'CHANGE_SIGNATURE_TYPE',
                params: {
                    uuid_account: this.account.uuid,
                    signature_type: this.signatureType
                }
            };
            this.$store.dispatch('setOTPData', OTPData);
            this.otpActive = true;

            switch (action) {
                case 'update':
                    this.updating = true;
                    break;
                case 'edit':
                    this.edit();
                    break;
                default:
                    break;
            }
        },
        otpValidated(otpVerification) {
            this.otpVerification = otpVerification;
            this.otpActive = false;
            if (this.updating) {
                this.save();
            }
        },
        getJuridicalIntervenerUuid() {
            return this.interveners?.find(intervener => intervener.document_type === 'CIF')?.uuid;
        },
        async uploadDocument(document, subcategory) {
            try {
                this.loading = true;
                const juridicalIntervenerUuid = this.getJuridicalIntervenerUuid();

                const payload = {
                    section: 'INTERVENER',
                    files: [document],
                    filesName: [document.name],
                    category: 'DOCUMENTATION',
                    subcategory: subcategory,
                    validated: false,
                    uuid: juridicalIntervenerUuid
                };

                await documentsService.upload(payload);
                this.loading = false;
            } catch (err) {
                this.$bvToast.toast(`${err.message}`, {
                    title: `Error ${err.name}`,
                    autoHideDelay: 10000,
                    variant: 'danger'
                });
            }
        },
        // sets the document in the juridicalDocuments array
        setDocumentFile(documentType, file) {
            this.juridicalDocuments.map(document => {
                if (document.key === documentType) {
                    document.file = file;
                }
            });
        },

        onFileChange(file, documentType) {
            if (!file) return;

            if (!this.acceptedFormats.split(',').includes(`.${file.type.split('/').pop()}`)) {
                this.showInvalidDocumentFormat = true;
                return;
            } else {
                this.showInvalidDocumentFormat = false;
            }

            if (file.size > this.maxSizeInBytes) {
                this.showInvalidDocumentSize = true;
                return;
            } else {
                this.showInvalidDocumentSize = false;
            }

            this.setDocumentFile(documentType, file);
        },

        save() {
            this.isLoading = true;

            let body = {
                draft_data: {
                    signature_type: this.signatureType
                },
                otp_verification: this.otpVerification
            };

            this.$accountService
                .updateAccount({}, body, this.uuidAccount)
                .then(res => {
                    this.isLoading = false;

                    // upload the juridical documents
                    if (this.isJuridicalIntervener) {
                        this.juridicalDocuments.map(document => {
                            if (document.file) {
                                this.uploadDocument(document.file, document.key);
                            }
                        });
                    }

                    // Success notification
                    this.$bvToast.toast('Se ha actualizado correctamente', {
                        title: 'Actualizado',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'success'
                    });
                    this.$emit('update', res.data.account);
                    this.edit(false);
                })
                .catch(err => {
                    this.isLoading = false;

                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });

                    console.error(err);
                });
        },
        setIntervenerRoles() {
            let intervenerMappedRoles = [];

            this.interveners.map(intervener => {
                intervenerMappedRoles = [];

                intervener.account_intervener_role.map(intervenerRole => {
                    this.rolesOptions.map(role => {
                        if (intervenerRole === role.key) {
                            intervenerMappedRoles.push(role);
                        }
                    });
                });

                intervener.account_intervener_role = intervenerMappedRoles;
            });
        },

        loadIntervenersData() {
            let intervenersList = [];

            // Get interveners
            this.$accountService
                .getAccountInterveners({}, this.uuidAccount)
                .then(response => {
                    response.data.accounts_intervener.map(intervener => {
                        //intervener.isMinor = isMinor(intervener);
                        intervener.account_intervener_role.map(role => {
                            if (role === 'TITULAR') {
                                intervener.isTitular = true;
                            }
                            return role;
                        });
                        intervenersList.push(intervener);
                    });

                    // Interveners array without beneficiaries
                    this.interveners = intervenersList;
                })
                .catch(error => console.error(error));
        }
    },
    computed: {
        isJuridicalIntervener() {
            return this.interveners.some(intervener => intervener.document_type === 'CIF');
        },
        // if isJuridicalIntervener, then juridicalDocuments should have at least one file
        validatedJuridicalDocuments() {
            if (this.isJuridicalIntervener) {
                return this.juridicalDocuments.some(document => document.file);
            }
            return true;
        },
        displayedSignatureType() {
            return (
                (this.accountDraftData && this.accountDraftData.signature_type) ||
                this.signatureType
            );
        },
        canEdit() {
            return this.status === 'FINALIZED';
        },
        moreThanOneIntervener() {
            return this.interveners.length > 1;
        },
        intervenersOTP() {
            const signatureTypesOTP = ['indistinta', 'conjunta', 'mancomunada'];
            const intervenerRoleOTP = ['titular', 'nudo_propietario', 'apoderado', 'administrador'];
            const signatureType = this.account.signature_type.toLowerCase();

            if (signatureTypesOTP.includes(signatureType)) {
                return this.interveners.filter(intervener => {
                    const intervenerRole = intervener.account_intervener_role[0].toLowerCase();

                    if (intervenerRoleOTP.includes(intervenerRole)) {
                        return intervener;
                    }
                });
            } else {
                const userIntervener = UsersService.getIntervenerFromLocalStore();
                return [userIntervener];
            }
        }
    }
};
